export default String.raw`
{% assign product = include -%}

{% comment -%}<!-- Current cart -->{% endcomment -%}
{% if customer.Carts[1] or customer.Cart.EditedOrderId -%}
	{% for cart in customer.Carts -%}
		{% if cart.Current -%}
			{% assign currentCartId = cart.Id -%}
			{% assign currentCartName = cart.Name -%}
		{% endif -%}
	{% endfor -%}
{% endif -%}

{% assign noProductOnControlledStock = false -%}
{% if product.StockLevel.QuantityControl == true and product.StockLevel.Value == 0 -%}
	{% assign noProductOnControlledStock = true -%}
{% else -%}
	{% assign noProductOnControlledStock = false -%}
{% endif -%}

{% if page.PageId == config.DefinedPages.CustomerProfile.Id and product != -1 -%}
	{% assign wishListProduct = true -%}
{% else -%}
	{% assign wishListProduct = false -%}
{% endif -%}


<div class="add-to-cart-form-container-js {% if product == -1 -%}serial-adding-form-js{% endif -%}" >
    {% if settings.productIsInCart == 'productIsInCart-yes' -%}
        <input type="hidden" id="isInCartId" value="{{product.Id}}">
    {% endif -%}

    <div class="form-js {% if product != -1 -%} add-to-cart-js container-js {% endif -%}">
        {% if product != -1 -%}
	        <input type="hidden" name="__action" value="Cart/Add">
	        <input type="hidden" name="productId" value="{{product.Id}}">
	        <div class="quantity-container">
                {% assign unitName = '' -%}
	            {% include 'partials/product/amount-stepper.html' with product -%}
                <span>
                    {% if wishListProduct -%}
                        {{ productUnit }}
                    {% else -%}
                        {{product.SaleUnit}}
                    {% endif -%}
                </span>
	        </div>
        {% endif -%}

        {% if unitMultiplicity > 0 and page.PageId == config.DefinedPages.ProductList.Id -%}
            <div class="multiplicity-info-js">{{ translations.Multiplicity }} <span class="multiplicity-js">{{ unitMultiplicity }}</span> <span class="name-js">{{ unitName }}</span></div>
        {% endif -%}

	    {% if wishListProduct == false and product.Price != null -%}
            {% assign productConditions1 = true -%}
        {% endif -%}
        {% if product.Availability.Status != 3 and noProductOnControlledStock == false -%}
            {% assign productConditions2 = true -%}
        {% endif -%}
        {% if productConditions1 and productConditions2 -%}
            {% assign productConditions3 = true -%}
        {% endif -%}
        {% if productConditions3 and customer.HidePrices == false -%}
            {% assign productConditions = true -%}
        {% endif -%}
          
	    {% if productConditions or product == -1 -%}
            {% assign buttonClasses = 'primary-action-button parent-container-reload-js add-to-cart-button-js' -%}

            {% if product == -1 -%}
                {% if page.PageId == config.DefinedPages.CustomerProfile.Id -%}
                	{% assign buttonClasses = buttonClasses | Append: ' serial-adding-from-wishlist-js' -%}
                {% else -%}
                	{% assign buttonClasses = buttonClasses | Append: ' serial-adding-to-cart-js' -%}
                {% endif -%}
            {% else -%}
                {% comment %}
                {% if customer.Carts[1] -%}
                    {% assign buttonClasses = buttonClasses | Append: ' choose-cart-js' -%}
                {% else -%}
                    {% assign buttonClasses = buttonClasses | Append: ' add-to-cart-update-client-area-js' -%}
                {% endif -%}
                {% endcomment %}
                {% assign buttonClasses = buttonClasses | Append: ' add-to-cart-update-client-area-js' -%}
            {% endif -%}

            <button class="{{buttonClasses}}" style="display: inline-flex;" {% if newQuery and settings.afterAddingToCart != 1 -%}data-url="{{ dataUrl }}"{% endif -%} {% if settings.afterAddingToCart == 1 -%}data-redirect-url="{{ redirectUrl }}"{% endif -%} {% if customer.Carts[1] -%} data-current-cart-id="{{ currentCartId }}" {% endif -%}>
                <span class="add-to-cart-label-js">
                    {% if settings.productIsInCart == 'productIsInCart-yes' -%}
                        <svg class="svgIcon svgIcon-inCart isInCartIcon-js svgIcon-inCart--PL hidden-js">
                            <use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#check-circle-{{settings.iconStyle}}"></use>
                        </svg>
                    {% endif -%}

                    {% capture mid -%}{% endcapture -%}
                    {% capture end -%} <span class="cart-name-js"> {{ currentCartName }}</span>{% endcapture -%}
                    {% assign cartsAmount = customer.Carts | Size -%}

                    {% if customer.Cart.EditedOrderId or cartsAmount > 1 -%}
                        {% if customer.Cart.EditedOrderId -%}
                            {% assign end = end | Prepend:mid -%}
                            {{ translations.AddToOrderSplitted | Format: end }}
                        {% elseif customer.Cart.Inquiry -%}
                            {{ translations.AddToInquirySplitted | Format: mid }}
                        {% else -%}
                            {{ translations.AddToCartSplittedWithName | Format: mid,end }}                                
                        {% endif -%}
                    {% elseif customer.Cart.Inquiry -%}
                        {{ translations.AddToInquirySplitted | Format: mid }}
                    {% else -%}
                        {{ translations.AddToCartSplitted | Format: mid }}
                    {% endif -%}
                </span>
                {% if customer.Cart.Inquiry -%}
                    <svg width="20" height="20">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#file-invoice-dollar-{{settings.iconStyle}}"></use>
                    </svg>
                {% else -%}
                    <svg width="20" height="20">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shopping-cart-{{settings.iconStyle}}"></use>
                    </svg>
                {% endif -%}
            </button>

            {% if settings.productIsInCart == 'productIsInCart-yes' -%}
                <div class="isInCartPopup isInCartPopup-js" style="display: none">
                    {{translations.productIsInCart}}
                </div>
            {% endif -%}

	        <div class="change-cart-label-js hidden-js">{{ translations.ChangeCart }}</div>
	    {% endif -%}
    </div>

    {% if customer.Carts[1] -%}
        <div class="form-js choose-cart-form-js hidden-js">
            <input type="hidden" name="__action" value="Cart/Change">
            <input type="hidden" name="id">
            <ul>
                {% for cart in customer.Carts -%}
                    <li class="choose-cart-js" data-id="{{ cart.Id }}" data-name="{{ cart.Name | H }}">{{ translations.Cart }} {{ cart.Name }}</li>
                {% endfor -%}
            </ul>
        </div>
    {% endif -%}
</div>
`